import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { AutoBonusPeriodsPageResponse } from "../../../domain/models/integration/auto-bonus-periods.model";
import { AutoBonusPeriodsPort } from "../../../app/ports/integration/auto-bonus-periods.port";
import { EnvMicroIntegration } from "../../config/env.micro.integration";
import { INTEGRATION_ENV } from "../../config/micros-env.tokens";
import { isAutoBonusPeriodsPageResponse } from "../../validators/integration/auto-bonus-periods.validator";

@Injectable()
export class AutoBonusPeriodsHttpAdapter implements AutoBonusPeriodsPort {
  private static readonly PERIODS_PATH = "/api/v1/auto-bonus/periods";

  constructor(
    private readonly http: HttpClient,
    @Inject(INTEGRATION_ENV) private readonly env: EnvMicroIntegration,
  ) {}

  getPeriods(page: number, size: number): Observable<AutoBonusPeriodsPageResponse> {
    const baseUrl = `${this.env.host}${this.env.apiBasePath}`.replace(/\/$/, "");
    let params = new HttpParams().set("size", size);
    if (page > 0) params = params.set("page", page);

    return this.http.get<unknown>(
      `${baseUrl}${AutoBonusPeriodsHttpAdapter.PERIODS_PATH}`,
      { params },
    ).pipe(
      map((response) => {
        if (!isAutoBonusPeriodsPageResponse(response)) {
          throw new Error("La respuesta de periodos de Bono Auto es inválida.");
        }
        return response;
      }),
    );
  }
}
